import React from "react";
import { Box, Button, Stack } from "@mui/material";
import { Text, Title } from "./style";
import { Link } from "react-router-dom";

function AccessNow() {
  return (
    <Box
      sx={{
        minHeight: "40vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <Title
        sx={{
          fontSize: {
            xs: "20px",
            md: "24px",
            fontWeight: 600,
            color: "#60656C",
          },
        }}
      >
        Get the right technology for your business !
      </Title>
      <Link to="/inventory/login">
        <Button
          variant="contained"
          sx={{
            mt: 2.4,
            fontFamily: "Poppins",
            px: { xs: "10px 20px", md: "50px" },
          }}
        >
          Access Now
        </Button>
      </Link>
    </Box>
  );
}

export default AccessNow;
